// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compositeTextInput_EwqLG {
  font: normal var( --size-inputMedium )/20px Inter;
  color: var( --color-base900 );
  border: 1px solid var( --color-base100 );
  outline: none;
  display: flex;
  overflow: hidden;
  transition: background-color 0.2s,color 0.2s,transform 0.2s;
  align-items: center;
  border-radius: var( --size-small );
  flex-direction: row;
  background-color: var( --color-white );
}
.compositeTextInput_EwqLG > .input_neM52 {
  font: normal var( --size-fontBodySmall )/20px Inter;
  color: #495a6e;
  padding: var( --size-medium ) var( --size-large );
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
}
.compositeTextInput_EwqLG > .input_neM52:focus {
  outline: none;
}
.compositeTextInput_EwqLG > .input_neM52::placeholder {
  color: var( --color-base200 );
  font-size: var( --size-inputMedium );
}
.compositeTextInput_EwqLG > .button_Mrt8Z {
  border-radius: 0px;
  background-color: transparent;
}
.compositeTextInput_EwqLG:focus-within {
  border-top-color: var( --color-brand400 );
  border-left-color: var( --color-brand400 );
  border-right-color: var( --color-brand400 );
  border-bottom-color: var( --color-brand400 );
}
.compositeTextInput_EwqLG[data-disabled=true] {
  color: var( --color-disabled );
  background-color: var( --color-base025 );
  border-top-color: var( --color-disabled );
  border-left-color: var( --color-disabled );
  border-right-color: var( --color-disabled );
  border-bottom-color: var( --color-disabled );
}
.compositeTextInput_EwqLG[data-error=true] {
  border-top-color: var( --color-danger500 );
  border-left-color: var( --color-danger500 );
  border-right-color: var( --color-danger500 );
  border-bottom-color: var( --color-danger500 );
}
.compositeTextInput_EwqLG.compositeTextInput-small_WU0AA > .input_neM52 {
  padding: var( --size-small ) var( --size-medium );
  font-size: var( --size-fontSmall );
}
.compositeTextInput_EwqLG.compositeTextInput-small_WU0AA {
  font-size: var( --size-fontBody );
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO > .input_neM52 {
  padding-left: 8px;
  padding-right: 4px;
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO > .input_neM52:focus {
  outline: none;
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO > .button_Mrt8Z {
  height: 40px;
  border-top-width: 1px;
  border-top-style: solid;
  border-left-width: 1px;
  border-left-style: solid;
  border-right-width: 1px;
  border-right-style: solid;
  border-bottom-width: 1px;
  border-bottom-style: solid;
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO > .button_Mrt8Z:focus-visible {
  border: 3px solid var( --color-FocusVisBorder );
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO {
  height: 40px;
  display: flex;
  min-width: 450px;
  align-items: center;
  padding-left: var( --size-medium );
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO[data-error=true] > .button_Mrt8Z {
  background-color: var( --color-disabled );
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO.compositeTextInput-mobileSearch_jGwtN > .button_Mrt8Z {
  width: 0px;
  margin: 0px;
  height: 0px;
  padding: 0px;
  min-width: 0px;
  max-width: 0px;
  background-color: transparent;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO.compositeTextInput-mobileSearch_jGwtN {
  width: 100%;
  padding: 4px 4px 4px 8px;
  min-width: 0px;
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO.compositeTextInput-mobileSearch_jGwtN[data-disabled=true] {
  color: var( --color-base400 );
  background-color: var( --color-base050 );
}
.compositeTextInput_EwqLG.compositeTextInput-password_LcnYh > .button_Mrt8Z {
  color: var( --color-base500 );
  background-color: transparent;
}
.compositeTextInput_EwqLG.compositeTextInput-password_LcnYh > .button_Mrt8Z:hover {
  background-color: transparent;
}
.compositeTextInput_EwqLG.compositeTextInput-password_LcnYh {
  width: 100%;
  height: 40px;
}
.compositeTextInput_EwqLG.compositeTextInput-scan_rBySE {
  border: 1px solid var( --color-base200 );
  padding-left: var( --size-padSmall );
  padding-right: var( --size-padSmall );
}
.compositeTextInput_EwqLG.compositeTextInput-fullWidth_efMOm {
  width: 100%;
}
.compositeTextInput_EwqLG.compositeTextInput-formInput_mPDso {
  width: 100%;
  background-color: var( --color-white );
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO.compositeTextInput-mobileSearch_jGwtN.compositeTextInput-attributeSelectorFilter_JAVA9 > .input_neM52 {
  width: 100%;
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO.compositeTextInput-mobileSearch_jGwtN.compositeTextInput-attributeSelectorFilter_JAVA9 > .input_neM52[disabled] {
  color: var( --color-base300 );
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO.compositeTextInput-mobileSearch_jGwtN.compositeTextInput-attributeSelectorFilter_JAVA9 > .button_Mrt8Z {
  width: 0px;
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO.compositeTextInput-mobileSearch_jGwtN.compositeTextInput-attributeSelectorFilter_JAVA9 {
  border: 1.5px solid var( --color-base200 );
  margin-top: var( --size-medium );
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO.compositeTextInput-mobileSearch_jGwtN.compositeTextInput-attributeSelectorFilter_JAVA9:focus-within {
  border-top-color: var( --color-brand300 );
  border-left-color: var( --color-brand300 );
  border-right-color: var( --color-brand300 );
  border-bottom-color: var( --color-brand300 );
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO.compositeTextInput-mobileSearch_jGwtN.compositeTextInput-attributeSelectorFilter_JAVA9[data-disabled=true] {
  background-color: var( --color-base100 );
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO.compositeTextInput-mobileSearch_jGwtN.compositeTextInput-formSearchBar_Qjdfs > .input_neM52 {
  width: 100%;
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO.compositeTextInput-mobileSearch_jGwtN.compositeTextInput-formSearchBar_Qjdfs > .button_Mrt8Z {
  width: 0px;
  height: 0px;
}
.compositeTextInput_EwqLG.compositeTextInput-attributeTableUnitEditor_ezFh7 > .input_neM52 {
  padding-left: 8px;
  padding-right: 8px;
}
.compositeTextInput_EwqLG.compositeTextInput-attributeTableUnitEditor_ezFh7 {
  width: 100%;
  height: 100%;
  border-radius: 0px;
}
.compositeTextInput_EwqLG.compositeTextInput-attributeDetailUnitEditor_Gqm3j > .input_neM52 {
  color: var( --color-base700 );
  padding: 0px var( --size-padMedium ) 0px 0px;
  text-align: right;
  font-weight: 600;
}
.compositeTextInput_EwqLG.compositeTextInput-attributeDetailUnitEditor_Gqm3j {
  width: 100%;
  height: 100%;
  padding: var( --size-padMedium ) var( --size-padLarge ) var( --size-padMedium ) var( --size-padMedium );
}
.compositeTextInput_EwqLG.compositeTextInput-attributeStringEditor_uE1FF > .input_neM52 {
  font-size: var( --size-fontBodySmall );
}
.compositeTextInput_EwqLG.compositeTextInput-attributeStringEditor_uE1FF {
  width: 100%;
}
.compositeTextInput_EwqLG.compositeTextInput-attributeFormEditor_XmxRl {
  font: normal var( --size-fontBodySmall )/20px Inter;
  color: var( --color-base700 );
  min-height: 40px;
  padding-right: var( --size-padSmall );
}
.compositeTextInput_EwqLG.compositeTextInput-inputGrowRounded_iBL6X {
  width: 100%;
  border-radius: var( --size-borderRadiusMedium );
}
.compositeTextInput_EwqLG.compositeTextInput-inputGrowRounded_iBL6X:hover {
  border: 1px solid var( --color-brand300 );
}
.compositeTextInput_EwqLG.compositeTextInput-inputGrowRounded_iBL6X:focus-within {
  border: 1px solid var( --color-brand300 );
  box-shadow: 0 1px 3px var( --color-shadowBase );
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO.compositeTextInput-button_ea9AJ > .button_Mrt8Z {
  border-top-left-radius: 0px;
  border-top-right-radius: 4px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/theme/CompositeTextInput.css"],"names":[],"mappings":"AAAA;EACE,iDAAiD;EACjD,6BAA6B;EAC7B,wCAAwC;EACxC,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,2DAA2D;EAC3D,mBAAmB;EACnB,kCAAkC;EAClC,mBAAmB;EACnB,sCAAsC;AACxC;AACA;EACE,mDAAmD;EACnD,cAAc;EACd,iDAAiD;EACjD,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;AAC9C;AACA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;AAC9C;AACA;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;EAC5C,6CAA6C;AAC/C;AACA;EACE,iDAAiD;EACjD,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,0BAA0B;AAC5B;AACA;EACE,+CAA+C;AACjD;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,wCAAwC;AAC1C;AACA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,qCAAqC;AACvC;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,sCAAsC;AACxC;AACA;EACE,WAAW;AACb;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,UAAU;AACZ;AACA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;AACA;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;AAC9C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,4CAA4C;EAC5C,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,uGAAuG;AACzG;AACA;EACE,sCAAsC;AACxC;AACA;EACE,WAAW;AACb;AACA;EACE,mDAAmD;EACnD,6BAA6B;EAC7B,gBAAgB;EAChB,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,+CAA+C;AACjD;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;EACzC,+CAA+C;AACjD;AACA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;AACjC","sourcesContent":[".compositeTextInput {\n  font: normal var( --size-inputMedium )/20px Inter;\n  color: var( --color-base900 );\n  border: 1px solid var( --color-base100 );\n  outline: none;\n  display: flex;\n  overflow: hidden;\n  transition: background-color 0.2s,color 0.2s,transform 0.2s;\n  align-items: center;\n  border-radius: var( --size-small );\n  flex-direction: row;\n  background-color: var( --color-white );\n}\n.compositeTextInput > .input {\n  font: normal var( --size-fontBodySmall )/20px Inter;\n  color: #495a6e;\n  padding: var( --size-medium ) var( --size-large );\n  border-top-width: 0px;\n  border-left-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 0px;\n}\n.compositeTextInput > .input:focus {\n  outline: none;\n}\n.compositeTextInput > .input::placeholder {\n  color: var( --color-base200 );\n  font-size: var( --size-inputMedium );\n}\n.compositeTextInput > .button {\n  border-radius: 0px;\n  background-color: transparent;\n}\n.compositeTextInput:focus-within {\n  border-top-color: var( --color-brand400 );\n  border-left-color: var( --color-brand400 );\n  border-right-color: var( --color-brand400 );\n  border-bottom-color: var( --color-brand400 );\n}\n.compositeTextInput[data-disabled=true] {\n  color: var( --color-disabled );\n  background-color: var( --color-base025 );\n  border-top-color: var( --color-disabled );\n  border-left-color: var( --color-disabled );\n  border-right-color: var( --color-disabled );\n  border-bottom-color: var( --color-disabled );\n}\n.compositeTextInput[data-error=true] {\n  border-top-color: var( --color-danger500 );\n  border-left-color: var( --color-danger500 );\n  border-right-color: var( --color-danger500 );\n  border-bottom-color: var( --color-danger500 );\n}\n.compositeTextInput.compositeTextInput-small > .input {\n  padding: var( --size-small ) var( --size-medium );\n  font-size: var( --size-fontSmall );\n}\n.compositeTextInput.compositeTextInput-small {\n  font-size: var( --size-fontBody );\n}\n.compositeTextInput.compositeTextInput-search > .input {\n  padding-left: 8px;\n  padding-right: 4px;\n}\n.compositeTextInput.compositeTextInput-search > .input:focus {\n  outline: none;\n}\n.compositeTextInput.compositeTextInput-search > .button {\n  height: 40px;\n  border-top-width: 1px;\n  border-top-style: solid;\n  border-left-width: 1px;\n  border-left-style: solid;\n  border-right-width: 1px;\n  border-right-style: solid;\n  border-bottom-width: 1px;\n  border-bottom-style: solid;\n}\n.compositeTextInput.compositeTextInput-search > .button:focus-visible {\n  border: 3px solid var( --color-FocusVisBorder );\n}\n.compositeTextInput.compositeTextInput-search {\n  height: 40px;\n  display: flex;\n  min-width: 450px;\n  align-items: center;\n  padding-left: var( --size-medium );\n}\n.compositeTextInput.compositeTextInput-search[data-error=true] > .button {\n  background-color: var( --color-disabled );\n}\n.compositeTextInput.compositeTextInput-search.compositeTextInput-mobileSearch > .button {\n  width: 0px;\n  margin: 0px;\n  height: 0px;\n  padding: 0px;\n  min-width: 0px;\n  max-width: 0px;\n  background-color: transparent;\n  border-top-width: 0px;\n  border-left-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 0px;\n}\n.compositeTextInput.compositeTextInput-search.compositeTextInput-mobileSearch {\n  width: 100%;\n  padding: 4px 4px 4px 8px;\n  min-width: 0px;\n}\n.compositeTextInput.compositeTextInput-search.compositeTextInput-mobileSearch[data-disabled=true] {\n  color: var( --color-base400 );\n  background-color: var( --color-base050 );\n}\n.compositeTextInput.compositeTextInput-password > .button {\n  color: var( --color-base500 );\n  background-color: transparent;\n}\n.compositeTextInput.compositeTextInput-password > .button:hover {\n  background-color: transparent;\n}\n.compositeTextInput.compositeTextInput-password {\n  width: 100%;\n  height: 40px;\n}\n.compositeTextInput.compositeTextInput-scan {\n  border: 1px solid var( --color-base200 );\n  padding-left: var( --size-padSmall );\n  padding-right: var( --size-padSmall );\n}\n.compositeTextInput.compositeTextInput-fullWidth {\n  width: 100%;\n}\n.compositeTextInput.compositeTextInput-formInput {\n  width: 100%;\n  background-color: var( --color-white );\n}\n.compositeTextInput.compositeTextInput-search.compositeTextInput-mobileSearch.compositeTextInput-attributeSelectorFilter > .input {\n  width: 100%;\n}\n.compositeTextInput.compositeTextInput-search.compositeTextInput-mobileSearch.compositeTextInput-attributeSelectorFilter > .input[disabled] {\n  color: var( --color-base300 );\n}\n.compositeTextInput.compositeTextInput-search.compositeTextInput-mobileSearch.compositeTextInput-attributeSelectorFilter > .button {\n  width: 0px;\n}\n.compositeTextInput.compositeTextInput-search.compositeTextInput-mobileSearch.compositeTextInput-attributeSelectorFilter {\n  border: 1.5px solid var( --color-base200 );\n  margin-top: var( --size-medium );\n}\n.compositeTextInput.compositeTextInput-search.compositeTextInput-mobileSearch.compositeTextInput-attributeSelectorFilter:focus-within {\n  border-top-color: var( --color-brand300 );\n  border-left-color: var( --color-brand300 );\n  border-right-color: var( --color-brand300 );\n  border-bottom-color: var( --color-brand300 );\n}\n.compositeTextInput.compositeTextInput-search.compositeTextInput-mobileSearch.compositeTextInput-attributeSelectorFilter[data-disabled=true] {\n  background-color: var( --color-base100 );\n}\n.compositeTextInput.compositeTextInput-search.compositeTextInput-mobileSearch.compositeTextInput-formSearchBar > .input {\n  width: 100%;\n}\n.compositeTextInput.compositeTextInput-search.compositeTextInput-mobileSearch.compositeTextInput-formSearchBar > .button {\n  width: 0px;\n  height: 0px;\n}\n.compositeTextInput.compositeTextInput-attributeTableUnitEditor > .input {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.compositeTextInput.compositeTextInput-attributeTableUnitEditor {\n  width: 100%;\n  height: 100%;\n  border-radius: 0px;\n}\n.compositeTextInput.compositeTextInput-attributeDetailUnitEditor > .input {\n  color: var( --color-base700 );\n  padding: 0px var( --size-padMedium ) 0px 0px;\n  text-align: right;\n  font-weight: 600;\n}\n.compositeTextInput.compositeTextInput-attributeDetailUnitEditor {\n  width: 100%;\n  height: 100%;\n  padding: var( --size-padMedium ) var( --size-padLarge ) var( --size-padMedium ) var( --size-padMedium );\n}\n.compositeTextInput.compositeTextInput-attributeStringEditor > .input {\n  font-size: var( --size-fontBodySmall );\n}\n.compositeTextInput.compositeTextInput-attributeStringEditor {\n  width: 100%;\n}\n.compositeTextInput.compositeTextInput-attributeFormEditor {\n  font: normal var( --size-fontBodySmall )/20px Inter;\n  color: var( --color-base700 );\n  min-height: 40px;\n  padding-right: var( --size-padSmall );\n}\n.compositeTextInput.compositeTextInput-inputGrowRounded {\n  width: 100%;\n  border-radius: var( --size-borderRadiusMedium );\n}\n.compositeTextInput.compositeTextInput-inputGrowRounded:hover {\n  border: 1px solid var( --color-brand300 );\n}\n.compositeTextInput.compositeTextInput-inputGrowRounded:focus-within {\n  border: 1px solid var( --color-brand300 );\n  box-shadow: 0 1px 3px var( --color-shadowBase );\n}\n.compositeTextInput.compositeTextInput-search.compositeTextInput-button > .button {\n  border-top-left-radius: 0px;\n  border-top-right-radius: 4px;\n  border-bottom-left-radius: 0px;\n  border-bottom-right-radius: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"compositeTextInput": `compositeTextInput_EwqLG`,
	"input": `input_neM52`,
	"button": `button_Mrt8Z`,
	"compositeTextInput-small": `compositeTextInput-small_WU0AA`,
	"compositeTextInput-search": `compositeTextInput-search_UapoO`,
	"compositeTextInput-mobileSearch": `compositeTextInput-mobileSearch_jGwtN`,
	"compositeTextInput-password": `compositeTextInput-password_LcnYh`,
	"compositeTextInput-scan": `compositeTextInput-scan_rBySE`,
	"compositeTextInput-fullWidth": `compositeTextInput-fullWidth_efMOm`,
	"compositeTextInput-formInput": `compositeTextInput-formInput_mPDso`,
	"compositeTextInput-attributeSelectorFilter": `compositeTextInput-attributeSelectorFilter_JAVA9`,
	"compositeTextInput-formSearchBar": `compositeTextInput-formSearchBar_Qjdfs`,
	"compositeTextInput-attributeTableUnitEditor": `compositeTextInput-attributeTableUnitEditor_ezFh7`,
	"compositeTextInput-attributeDetailUnitEditor": `compositeTextInput-attributeDetailUnitEditor_Gqm3j`,
	"compositeTextInput-attributeStringEditor": `compositeTextInput-attributeStringEditor_uE1FF`,
	"compositeTextInput-attributeFormEditor": `compositeTextInput-attributeFormEditor_XmxRl`,
	"compositeTextInput-inputGrowRounded": `compositeTextInput-inputGrowRounded_iBL6X`,
	"compositeTextInput-button": `compositeTextInput-button_ea9AJ`
};
export default ___CSS_LOADER_EXPORT___;
